<template>
  <div class="OskefuCG">
    <div class="QHRCbutton">
      <div class="float-button" @click="show = !show">
        <span class="iconfont icon-qiyeduxiang flex-center" style="font-size: 25px"></span>
      </div>
    </div>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="title" width="800px">
      <table class="QHtable">
        <tr>
          <td style="width: 100px">联系客服</td>
          <td>温永斌</td>
        </tr>
        <tr>
          <td>联系电话</td>
          <td>13168035947</td>
        </tr>
        <tr>
          <td>联系微信</td>
          <td>13168035947</td>
        </tr>
        <tr>
          <td>专利企业</td>
          <td>深圳万知达技术转移中心有限公司</td>
        </tr>
      </table>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title:"联系我们",
      show: false,
      list: []
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | 手动启动客服信息
    // +----------------------------------------------------------------------
    hello(title) {
      this.title = title||"深圳万知达技术转移中心有限公司客服";
      this.show = true;
    },
  },
};
</script>
<style scoped>
.OskefuCG td {
  font-size: 16px;
}
</style>
